import { useEffect, useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import { refreshAppShell } from '../lib/appRecovery';

export default function LoadingScreen() {
  const { theme } = useTheme();
  const [slowLoad, setSlowLoad] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setSlowLoad(true), 9000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: theme.bg,
      gap: 16,
    }}>
      <div style={{
        width: 52,
        height: 52,
        borderRadius: '18.5%',
        background: 'linear-gradient(145deg, #c0a060, #8a7040, #a89050)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 26,
        fontWeight: '700',
        color: '#0b0f1a',
        fontFamily: "'DM Sans', sans-serif",
        border: '1.5px solid #c0a060',
      }}>S</div>
      <div style={{ color: theme.textMuted, fontFamily: 'Calibri, sans-serif', fontSize: 14 }}>
        Loading SiteScope…
      </div>
      {slowLoad && (
        <div style={{
          maxWidth: 300,
          textAlign: 'center',
          color: theme.textMuted,
          fontFamily: "'DM Sans', sans-serif",
          fontSize: 13,
          lineHeight: 1.45,
        }}>
          <div style={{ marginBottom: 12 }}>
            This is taking longer than expected. Refreshing the app usually fixes a stale browser session.
          </div>
          <button
            type="button"
            onClick={refreshAppShell}
            style={{
              background: '#c0a060',
              color: '#081525',
              border: 'none',
              borderRadius: 8,
              padding: '10px 16px',
              fontWeight: 800,
              cursor: 'pointer',
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            Refresh app
          </button>
        </div>
      )}
    </div>
  );
}
